import React from 'react';
import _ from 'lodash';

import DropdownDisplay from '../dropdown-display.jsx';
import DropdownInput from '../dropdown-input.jsx';
import DropdownList from '../dropdown-list.jsx';
import Option from '../option';

export default class InputtableDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mousedDownOnDropdown: false
    };

    this.onMouseDown = this.onMouseDown.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  onChangeHandler(ev) {
    // We only want to execute the change handler if they haven't done so through the dropdown
    // Without this, if you focused into the input first then select an option on the dropdown,
    // the changeHandler is called twice which has caused selection issues on PB-2451
    if ( ! this.state.mousedDownOnDropdown) {
      this.props.changeHandler(ev);
    }

    this.setState({
      mousedDownOnDropdown: false
    });
  }

  onMouseDown() {
    this.setState({
      mousedDownOnDropdown: true
    });
  }

  generateOptionList() {
    if (_.isUndefined(this.props.options)) {
      return null;
    }

    return _.map(this.props.options, (option, index) => {
      return (
        <Option
          onClick={this.props.changeHandler}
          value={option.value}
          key={index}
          selected={option.selected}
        >
          {option.label}
        </Option>
      );
    });
  }

  render() {
    return (
      <div>
        <DropdownDisplay
          clickHandler={this.props.toggleDropdown}
        >
          <DropdownInput
            value={this.props.value || "Choose"}
            changeHandler={this.onChangeHandler}
          />
        </DropdownDisplay>
        <DropdownList
          open={this.props.open}
          onMouseDown={this.onMouseDown}
        >
          {this.generateOptionList()}
        </DropdownList>
      </div>
    );
  }
}


InputtableDropdown.propTypes = {
  open: React.PropTypes.bool,
  toggleDropdown: React.PropTypes.func,
  value: React.PropTypes.string,
  changeHandler: React.PropTypes.func,
  options: React.PropTypes.array
};



// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown-types/inputtable-dropdown.jsx